// extracted by mini-css-extract-plugin
export default {"btnRestric":"ProductBuildPageTableRow_btnRestric__87KMp","btnRoyalty":"ProductBuildPageTableRow_btnRoyalty__CKGnO"};